<template>
    <div class="stretch-vertical home">
        <div class="text-content-section stretch-vertical" v-html="pageContent"></div>
    </div>
</template>

<style>
    .main-intro {
        padding-left: 4em;
        padding-right: 4em;
        padding-top: 1em;
        margin-bottom: 4em;
    }

    .home-bg-links {
        height:100%;
    }

    .ba-card {
        border-radius: 5px;
        background-color: #FFFFFF;
        opacity: 0.8;
        text-align: center;
        padding-top: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;

        backdrop-filter: blur(49px);
        -webkit-backdrop-filter: blur(49px);

    }

    @media (max-width: 575px) { 
        .home-bg {
            padding-top: 0 !important;
        }
    }


    @media (min-width: 992px) {
        .ba-card {
            min-height:8rem;
            padding-bottom: 1rem;
            height: 8rem;
        }
    }

    .card-headline {
        font-family: 'Segoe UI', 'black';
        color: #2C3D47;
        font-weight: bold;
        font-size: 1.25em;
        text-decoration: none !important;
    }

    .card-headline:hover {
        color:#2C3D47;
    }
</style>

<script>
/* eslint-disable */
import axios from 'axios';
import { TokenService } from '../services/token.service'

export default {
    
    data() {
        return {
             loggedIn: false,
             rootTabs: [],
             pageContent: '',
        }
    },
    created: function() {
        // axios.get('/api/webtabs/tree').then(res => {
        //     this.rootTabs = res.data.filter((o ,i) => i < 12 && o.Name !== 'Home');
        // });
    },
    mounted: function () {
        this.checkLoggedIn();
        const vm = this;    
        axios.get('api/pagecontent/2cc327ac-82a9-440c-ba3e-19a463e43db4').then(function (response) {
            if (response.status === 200) {
                vm.setPageContent(response.data);
            } 
        })
    },
    methods: {
        checkLoggedIn: function () {
            if (TokenService.getToken()) {
                this.loggedIn = true;
            } else {
                this.loggedIn = false;
            }
        },
        getLink: tab => {
            return tab.Children.length > 0 ? tab.Children[0].Id : tab.Id
        },
        setPageContent: function(page) {
            var pattern = /a href=/g;
            var rawMarkDownText = marked(page.Content);
            this.pageContent = rawMarkDownText.replace(pattern,"a target='_blank' href=");
        },
    },
}
</script>
